const validPositiveInteger = (value) => {
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
};

const legacyUrl = (values) => {
  const raw = values && values.next_page_url;
  if (typeof raw !== "string" || !raw) return null;

  try {
    return new URL(raw, "https://catalog-list.invalid");
  } catch (_error) {
    return null;
  }
};

export const catalogLegacyQuery = (values, key) => legacyUrl(values)?.searchParams.get(key) || null;

export const catalogListLimit = (values) =>
  validPositiveInteger(values && values.limit) || validPositiveInteger(catalogLegacyQuery(values, "limit"));

// Laravel paginator links can contain an absolute host. Keep only the page
// token and the query assembled by the caller, then rebuild against Flask.
export const localCatalogAction = (route, values = {}, query = "") => {
  const input = values || {};
  const page = validPositiveInteger(input.page) || validPositiveInteger(catalogLegacyQuery(input, "page"));
  const parts = [];
  if (page) parts.push(`page=${page}`);
  if (query) parts.push(query);
  return `${route}${parts.length ? `?${parts.join("&")}` : ""}`;
};
